import { render, staticRenderFns } from "./HoribaDataTable.vue?vue&type=template&id=20d0e4a5"
import script from "./HoribaDataTable.vue?vue&type=script&lang=js"
export * from "./HoribaDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports